"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _Parser = _interopRequireDefault(require("../parse/Parser"));
var _ModelExporter = _interopRequireDefault(require("../export/ModelExporter"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _import(str, format) {
  var database = _Parser["default"].parse(str, format);
  var dbml = _ModelExporter["default"]["export"](database.normalize(), 'dbml');
  return dbml;
}
var _default = {
  "import": _import
};
exports["default"] = _default;